@if (path()) {
  <img [alt]="area()" [ngSrc]="path()" height="32" width="32" class="mr-3 align-middle">
}
